const LOGO_BASE = '/images/mutual_fund/amc_logos'
const DISTRIBUTOR_BASE = '/images/mutual_fund/distributors'

export const MockFundAmc = {
  ADITYA_BIRLA_SUN_LIFE: 'ADITYA_BIRLA_SUN_LIFE',
  AXIS: 'AXIS',
  BAJAJ_FINSERV: 'BAJAJ_FINSERV',
  BANDHAN: 'BANDHAN',
  BANK_OF_INDIA: 'BANK_OF_INDIA',
  BARODA_BNP_PARIBAS: 'BARODA_BNP_PARIBAS',
  CANARA_ROBECO: 'CANARA_ROBECO',
  DEFAULT: 'DEFAULT',
  DSP: 'DSP',
  EDELWEISS: 'EDELWEISS',
  FRANKLIN_TEMPLETON: 'FRANKLIN_TEMPLETON',
  GROWW: 'GROWW',
  HDFC: 'HDFC',
  HELIOS_CAPITAL: 'HELIOS_CAPITAL',
  HSBC: 'HSBC',
  ICICI_PRUDENTIAL: 'ICICI_PRUDENTIAL',
  INVESCO: 'INVESCO',
  ITI: 'ITI',
  JM_FINANCIAL: 'JM_FINANCIAL',
  KOTAK_MAHINDRA: 'KOTAK_MAHINDRA',
  LIC_MUTUAL_FUND: 'LIC_MUTUAL_FUND',
  MAHINDRA_MANULIFE: 'MAHINDRA_MANULIFE',
  MIRAE: 'MIRAE',
  MOTILAL_OSWAL: 'MOTILAL_OSWAL',
  NAVI: 'NAVI',
  NIPPON_LIFE_INDIA: 'NIPPON_LIFE_INDIA',
  NJ: 'NJ',
  OLD_BRIDGE: 'OLD_BRIDGE',
  ONE_ASSET_MANAGEMENT_360: 'ONE_ASSET_MANAGEMENT_360',
  PGIM_INDIA: 'PGIM_INDIA',
  PPFAS: 'PPFAS',
  QUANT_MONEY_MANAGERS: 'QUANT_MONEY_MANAGERS',
  QUANTUM: 'QUANTUM',
  SAMCO: 'SAMCO',
  SBI: 'SBI',
  SHRIRAM: 'SHRIRAM',
  SUNDARAM: 'SUNDARAM',
  TATA: 'TATA',
  TAURUS: 'TAURUS',
  TRUST: 'TRUST',
  UNION: 'UNION',
  UTI: 'UTI',
  WHITEOAK_CAPITAL: 'WHITEOAK_CAPITAL',
  ZERODHA: 'ZERODHA',
} as const

export type MockFundAmc = (typeof MockFundAmc)[keyof typeof MockFundAmc]

const VALID_AMCS = new Set<string>(Object.values(MockFundAmc))

export function getFundLogoPath(amc?: MockFundAmc | null): string {
  const key = amc && VALID_AMCS.has(amc) ? amc : MockFundAmc.DEFAULT
  return `${LOGO_BASE}/${key}/base_logo.png`
}

export const MockDistributor = {
  FIVE_PAISA: '5PAISA',
  ADITYA_BIRLA_SUN_LIFE_AMC: 'ADITYA_BIRLA_SUN_LIFE_AMC',
  ANAND_RATHI_WEALTH_MANAGEMENT: 'ANAND_RATHI_WEALTH_MANAGEMENT',
  ANGEL_ONE: 'ANGEL_ONE',
  ASSETPLUS: 'ASSETPLUS',
  AXIS_BANK: 'AXIS_BANK',
  AXIS_SECURITIES: 'AXIS_SECURITIES',
  BACHATT: 'BACHATT',
  BAJAJ_CAPITAL: 'BAJAJ_CAPITAL',
  BANK_OF_BARODA: 'BANK_OF_BARODA',
  BLUECHIP: 'BLUECHIP',
  CAMS: 'CAMS',
  CANARA_BANK: 'CANARA_BANK',
  DEFAULT: 'DEFAULT',
  DEZERV: 'DEZERV',
  DHAN: 'DHAN',
  EASTERN_FINANCIERS: 'EASTERN_FINANCIERS',
  ET_MONEY: 'ET_MONEY',
  FISDOM: 'FISDOM',
  FUNDSINDIA: 'FUNDSINDIA',
  GEOJIT: 'GEOJIT',
  GROWW: 'GROWW',
  HDFC: 'HDFC',
  HDFC_BANK: 'HDFC_BANK',
  HDFC_SECURITIES: 'HDFC_SECURITIES',
  HDFC_WMS: 'HDFC_WMS',
  ICICI_BANK: 'ICICI_BANK',
  ICICI_SECURITIES: 'ICICI_SECURITIES',
  IDBI_BANK: 'IDBI_BANK',
  IDFC: 'IDFC',
  IIFL_SECURITIES: 'IIFL_SECURITIES',
  INDMONEY: 'INDMONEY',
  INDUSIND_BANK: 'INDUSIND_BANK',
  INTEGRATED: 'INTEGRATED',
  JM_FINANCIAL_AMC: 'JM_FINANCIAL_AMC',
  JUPITER_MONEY: 'JUPITER_MONEY',
  KFIN: 'KFIN',
  KOTAK_MAHINDRA: 'KOTAK_MAHINDRA',
  KOTAK_SECURITIES: 'KOTAK_SECURITIES',
  KUVERA: 'KUVERA',
  MOTILAL_OSWAL: 'MOTILAL_OSWAL',
  NIYO_MONEY: 'NIYO_MONEY',
  NJ_WEALTH: 'NJ_WEALTH',
  PAISABAZAAR: 'PAISABAZAAR',
  PAYTM: 'PAYTM',
  PHONEPE: 'PHONEPE',
  PRUDENT_CORPORATE: 'PRUDENT_CORPORATE',
  RIGHT_HORIZONS: 'RIGHT_HORIZONS',
  SBI_SECURITIES: 'SBI_SECURITIES',
  SBI_WEALTH_MANAGEMENT: 'SBI_WEALTH_MANAGEMENT',
  SCRIPON: 'SCRIPON',
  SHAREKHAN: 'SHAREKHAN',
  SUNDARAM_WEALTH_MANAGEMENT: 'SUNDARAM_WEALTH_MANAGEMENT',
  TATA_SECURITIES: 'TATA_SECURITIES',
  UPSTOX: 'UPSTOX',
  ZERODHA: 'ZERODHA',
  ZFUNDS: 'ZFUNDS'
} as const

export type MockDistributor = (typeof MockDistributor)[keyof typeof MockDistributor]

const VALID_DISTRIBUTORS = new Set<string>(Object.values(MockDistributor))

export function getDistributorLogoPath(distributor?: MockDistributor | null): string {
  const key = distributor && VALID_DISTRIBUTORS.has(distributor) ? distributor : MockDistributor.DEFAULT
  return `${DISTRIBUTOR_BASE}/${key}/base_logo.png`
}
